import ufs from '../../data/ufs';

window.CampaignRewardsStoragePage = {
    getUfs(){
        return ufs;
    },
    createNewShippingOption() {
        let select = document.createElement('select');
        select.setAttribute('class','form-control');
        select.style.height= '40px';
        select.style.marginTop= '10px';
        select.setAttribute('name',`reward_shipping_rule_state[]`);

        select.innerHTML = "<option>Selecione o estado</option>";


        for(let uf of CampaignRewardsStoragePage.getUfs()){
            select.innerHTML += "<option value='" + uf.sigla  + "'>" + uf.nome + "</option>";
        }

        let inputGroup = document.createElement('div');
        inputGroup.setAttribute('class','input-group mt10');
        let input = document.createElement('input');

        input.setAttribute('type','text');
        input.setAttribute('name',`reward_shipping_rule_cost[]`);
        input.setAttribute('class','form-control money');
        input.setAttribute('placeholder','R$ ');

        let p = document.createElement('p'),
            a = document.createElement('a');
        a.setAttribute('href','javascript:void(0)');
        a.setAttribute('class','text-pink reward_shipping_rule_delete');
        a.innerHTML = '<i class="fa fa-lg fa-fw fa-trash-o"></i>';
        a.setAttribute('style','height: 22px;padding: 6px 0;');
        p.append(a);
        p.setAttribute('style','position:relative;margin-top: 30px');

        inputGroup.innerHTML= "<span class='input-group-addon'>R$</span>";
        inputGroup.innerHTML+= input.outerHTML;
        inputGroup.innerHTML+= "<span class='input-group-addon'>,00</span>";

        setTimeout(function(){
            $('#reward_shipping_rule_state_wrapper').append(select);
            $('#reward_shipping_rule_cost_wrapper').append(inputGroup);
            $('#reward_shipping_rule_delete_wrapper').append(p);
            CampaignRewardsStoragePage.loadMoney();
        });
    },
    loadMoney(){
        $('.money').mask('000.000.000.000.000', {reverse: true});
    },
    load() {
        if($('.campanha-recompensas-store').length > 0) {
            CampaignRewardsStoragePage.loadMoney();

            $('#reward_active').bootstrapSwitch({
                onColor: 'success',
                size: 'mini',
                onSwitchChange: function(event,state){
                    $('label[for="reward_active"]').html(state ? "ATIVA" : "INATIVA");
                    $(this).attr('checked',state);
                }
                // onColor: 'pink',
            });
            $('#international_delivery_enabled').bootstrapSwitch({
                onColor: 'success',
                size: 'mini',
                onSwitchChange: function(event,state){
                    $(this).attr('checked',state);

                    let disabled = true,
                        method = 'removeClass';
                    if($(this).is(':checked')){
                        method = 'addClass';
                        disabled = false;
                    }

                    $('[name=international_delivery_cost]').attr({disabled: disabled});
                    $('.international_delivery_label')[method]('disabled-bg-white');
                }
                // onColor: 'pink',
            });

            /**
             * WATCHER FOR BTN RADIO
             */
            $('.btn-radio input').change(function(){
                $('.btn-radio').removeClass('active');
                $('.btn-radio input:checked').parent().addClass('active');
            });

            /**
             * WATCHER FOR LIMITED REWARD AND DELIVERY FORM
             */

            $('[name=limited_reward]').change(function(){
                $('.quantity-field').slideToggle();
            });

            $('[name=deliverable]').change(function(){
                $('.delivery-form').slideToggle();
            });

            $('.btn-add-delivery-rule').click(function(){
                CampaignRewardsStoragePage.createNewShippingOption();
            });

            $('body').on('click','.reward_shipping_rule_delete',function(){
                let element = this,
                    i = 1;

                $('.reward_shipping_rule_delete').each(function(){
                    if(this.isSameNode(element)){
                        $('#reward_shipping_rule_state_wrapper select:nth-child('+i+')').fadeOut(function(){
                            $(this).remove();
                        });

                        $('#reward_shipping_rule_cost_wrapper div.input-group:nth-child('+i+')').fadeOut(function(){
                            $(this).remove();
                        });

                        $(element).fadeOut(function(){
                            $(this).remove();
                        });
                    }
                    i++;
                })
            });

            $('#campanha_recompensas_store_wrapper').submit(function(e){
                let $form = $(this);
                $form.find('button[type=submit]').button('loading');

                e.preventDefault();
                $.post($form.attr('action'),$form.serialize(),function(data){
                    if(data.error){
                        goTopComponent.goTop();
                        let message = document.createElement('div');
                        message.setAttribute('class','alert alert-danger');
                        message.innerHTML = `<strong>${data.error}</strong>`;

                        $form.prepend(message);
                        $form.find('button[type=submit]').button('reset');
                        setTimeout(function(){
                            $(message).fadeOut(700,function(){
                                $(this).remove();
                            });
                        },5000);
                    }else{
                        window.location.href = data.url;
                    }
                });
                return false;
            })
        }
    }
};

CampaignRewardsStoragePage.load();